"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const IconListContent_1 = __importDefault(require("./IconListContent"));
exports.default = IconListContent_1.default;
